import styled from 'styled-components'

export const Page = styled.main`
    width: 100%;
    max-width: 1240px;
    margin: 0 auto;
    padding: 124px clamp(18px, 4vw, 52px) 64px;
    animation: notificationPageReveal 0.45s ease both;

    @keyframes notificationPageReveal {
        from { opacity: 0; transform: translateY(10px); }
        to { opacity: 1; transform: translateY(0); }
    }

    @media (prefers-reduced-motion: reduce) {
        animation: none;
    }
`;

export const PageHeader = styled.header`
    max-width: 720px;
    margin-bottom: clamp(42px, 6vw, 72px);
`;

export const PageIntro = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

export const PageEyebrow = styled.div`
    color: ${({ theme }) => theme.palette.blue.main};
    font-family: Poppins, sans-serif;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.16em;
    text-transform: uppercase;
`;

export const PageTitle = styled.h1`
    margin: 0;
    color: ${({ theme }) => theme.palette.colors.text};
    font-family: Gilroy, sans-serif;
    font-size: clamp(38px, 5vw, 58px);
    font-weight: 700;
    letter-spacing: -0.045em;
    line-height: 0.98;
`;

export const PageSubtitle = styled.p`
    max-width: 560px;
    margin: 4px 0 0;
    color: ${({ theme }) => theme.palette.colors.muted};
    font-family: Lato, sans-serif;
    font-size: 15px;
    line-height: 1.6;
`;

export const ListSection = styled.section`
    width: 100%;
`;

export const ListHeader = styled.header`
    min-height: 70px;
    padding-bottom: 18px;
    border-bottom: 1px solid ${({ theme }) => theme.palette.colors.borderStrong};
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 24px;

    @media (max-width: 600px) {
        align-items: stretch;
        flex-direction: column;
        gap: 16px;
    }
`;

export const ListHeadingGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;
`;

export const ListTitle = styled.h2`
    margin: 0;
    color: ${({ theme }) => theme.palette.colors.text};
    font-family: Gilroy, sans-serif;
    font-size: 24px;
    font-weight: 700;
    letter-spacing: -0.02em;
`;

export const ListMeta = styled.div`
    color: ${({ theme }) => theme.palette.colors.subdued};
    font-family: Lato, sans-serif;
    font-size: 13px;
`;

export const ListAction = styled.div`
    width: fit-content;
    align-self: flex-end;

    && > .MuiButton-root {
        width: auto;
    }

    @media (max-width: 600px) {
        align-self: flex-start;
    }
`;

export const NotificationList = styled.ul`
    margin: 0;
    padding: 0;
    background: ${({ theme }) => theme.palette.colors.backgroundTransparent};

    > li:last-child button {
        border-bottom: 0;
    }
`;
